import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import TrustComparison from './components/TrustComparison';
import SEOSection from './components/SEOSection';
import ArticlePreview from './components/ArticlePreview';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main>
      <Navbar />
      <Hero />
      <CategorySection />
      <TrustComparison />
      <SEOSection />
      <ArticlePreview />
      <CTASection />
      <Footer />
    </main>
  );
}